import { render, staticRenderFns } from "./RecallReminderReportDrawer.vue?vue&type=template&id=da83499e&scoped=true"
import script from "./RecallReminderReportDrawer.vue?vue&type=script&lang=js"
export * from "./RecallReminderReportDrawer.vue?vue&type=script&lang=js"
import style0 from "./RecallReminderReportDrawer.vue?vue&type=style&index=0&id=da83499e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da83499e",
  null
  
)

export default component.exports